/* eslint-disable @typescript-eslint/naming-convention */

// 💀⚡💀 DO NOT EDIT THIS FILE 💀⚡💀 DO NOT EDIT THIS FILE 💀⚡💀 DO NOT EDIT THIS FILE 💀⚡💀

/*////////////////////////////////////////////////////////////////////////////////////////////////

  ##### ##### ##### ##### |   This file is autogenerated using an Nx workspace schematic.
  #       #   #   # #   # |   Manual changes should not be needed. After adding your feature 
  #####   #   #   # ##### |   to software security, simply regenerate this file by running
      #   #   #   # #     |   `nx g security-constants`. If there is an issue
  #####   #   ##### #     |   with the generated file, check tools/generators/security-constants

////////////////////////////////////////////////////////////////////////////////////////////////*/
import { SecurityObject } from './permission.model';
export const securityObj: SecurityObject = {
  data: [
    {
      featureGroupName: '',
      features: [
        {
          permissionId: null,
          featureId: '6fda5d89-eb76-4f17-b927-24004a1613f2',
          featureName: 'Account Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd4759063-595b-4efc-b094-0a0313bccaae',
          featureName: 'Add New Material',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bd40d61f-3ef3-4755-8042-8ae269a11a17',
          featureName: 'BD Opportunity Totals',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e1c91199-8fd6-4cb6-b8f7-01d7a2dfef06',
          featureName: 'BD Opportunity Values',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'dd666118-f492-4972-8563-50ba0965c084',
          featureName: 'Contact Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd8ba05cf-1d1e-4684-b218-d59d06633ce6',
          featureName: 'Data Reconciliation Admin',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '94e2b367-1a5e-4d83-9b8b-dfd6038bb571',
          featureName: 'Equipment Dispatch Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '806b79a4-5b71-4784-a9e9-8aad0e209c42',
          featureName: 'Equipment Dispatch Grid',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b14eee06-1c0e-4d10-94df-e35387a88fc4',
          featureName: 'Export',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'cf032b6d-d057-44bf-bcb0-6360bc5001ac',
          featureName: 'Form Templates',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b38a14b4-9222-4e51-ae00-0005294c77f0',
          featureName: 'HR Edit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7d48aba1-d35d-4e8a-8fcc-b5dd5625d12b',
          featureName: 'I-9 Management',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '104aed04-fffc-4d1b-86ea-62ea1fd7d1dd',
          featureName: 'Lookup Packets',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3e8083ae-f144-43dc-b3ca-6da9fd3f2a72',
          featureName: 'Manage Users',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2c02096d-cf8d-4e2e-8094-3f3c07c41789',
          featureName: 'Send Docs to Re-Sign',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f29dd3c3-700b-4968-9958-7b4434ba2113',
          featureName: 'View App Switcher',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '393dc619-4444-4e48-bde9-02eaac5c63b6',
          featureName: 'Custom Export Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b315f122-a44e-43f6-a500-5e6329a0aa2a',
          featureName: 'Allow Dispatch of 2 Month or more of Inactivity',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b943412d-3ecc-47cd-8759-46cdcf06f22d',
          featureName: 'Allow Dispatch of 6 Month or more of Inactivity',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9f84a0aa-01d6-4928-b64d-d7311338ceb8',
          featureName: 'Allow Dispatch of Inactive Employees',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4e19d31d-7144-4adc-bc10-347d9da7df7b',
          featureName: 'Allow Dispatch of Inactive Employees 0-6 Months',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ed6a80e5-cdd0-4dc7-9593-17bcfd2fc8f5',
          featureName:
            'Allow Dispatch of Inactive Employees with Caution Status',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'af2014dd-74d0-457d-afb5-cabd09482669',
          featureName: 'Allow Per Diem Above 500',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0cedbffa-742b-4ffc-89be-74fa7d037098',
          featureName: 'Copy Job Crew',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f5506b34-9e73-4188-853c-c79dd618905c',
          featureName: 'Dispatch History',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f34fd454-ced9-4f31-b343-50a145df71dc',
          featureName: 'Transfer Employee Company',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1b1d5ef6-45b8-468f-a943-419b2cbc3cdd',
          featureName: 'Auto Populate Wage',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b9a3cffa-b739-4f95-9dde-1b6c52e3bb02',
          featureName: 'Contact Per Diem',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2694c08e-535a-4fcc-ba6a-10abdb9c2577',
          featureName: 'Contract OT/PT Factor',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0340e3b0-24da-42e8-8388-6d050fd15629',
          featureName: 'Dispatch Contract Rate',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '878173bc-24a4-41c5-8eff-bf3470162583',
          featureName: 'Field Pay Rate',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '399a8a51-39c9-4d99-893a-73cf85938e83',
          featureName: 'File Pay Rate',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '76d59e9e-1aeb-43ce-be11-2cce0699a850',
          featureName: 'Non Billable Pay Rate ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a9f8bff2-12e7-4c62-82fc-958a343faa43',
          featureName: 'Shop Pay Rate',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e29b9f6b-3b28-4950-b00d-6b5ac0a0cc10',
          featureName: 'Wage Over 99',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fc54bfd4-1432-4f5b-83b0-9455d5818cb6',
          featureName: 'Admin Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '89986eee-72b0-426e-aec5-a36a9d9a7ad3',
          featureName: 'Admin Page Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c4abb77b-a16f-4a4f-802b-8b485698f4da',
          featureName: 'Change COMPLIANCE HOLD status',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '17e3b55f-5194-4e30-ad60-008458263790',
          featureName:
            'Save DECLINED from CAUTION/NOT REHIREABLE/MEDICAL RELEASE REQUIRED',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4d5f39a5-e2d9-4ae5-8899-d4fa62118823',
          featureName: 'Save DECLINED from DISPATCHED',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f1987f1f-84e4-4286-a9ca-6259011c407d',
          featureName: 'Temp',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5be435c6-69d3-413a-95d5-690effd0c3c6',
          featureName: 'Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b3211494-0541-457b-b650-e9ff65a8cc61',
          featureName: 'Background Tab MVR',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f6da7846-ed19-4f85-9890-caccd89e9da3',
          featureName: 'FullSSN',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '89a01c1f-2719-41be-b1cb-5f3e4cd2a1fb',
          featureName: 'Job History Pay Rate',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e24cc6d6-2dba-44a7-a99e-a47f9f3c7989',
          featureName: 'Rehire Status - Caution',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '71c9b663-79e6-4aa5-9e67-f8238124bad9',
          featureName: 'Rehire Status - Not Rehirable',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5f9d0a96-fb3d-4010-990a-4640f6aa2a0d',
          featureName: 'Equipment Administration Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5bb29077-c256-4d25-84e5-5b32d9026e02',
          featureName: 'Corrections Audit Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8b09e20c-f33b-4b2e-8bda-cec3df4e8217',
          featureName: 'Corrections Audit Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b6c10796-3ccd-43e7-b98d-f900871fefb0',
          featureName: 'Equipment Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '21596cce-e7d3-4f85-8620-eb92fd6fa0b6',
          featureName: 'Equipment Dashboard Bulk Edit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '28714d10-3583-4d7c-9a1a-643e6db030dd',
          featureName: 'Equipment Dashboard Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9f9ce6c9-8930-4332-b537-dd290ec8abd4',
          featureName: 'Equipment Dashboard Scorecard Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1e867bda-a9fa-4bd1-87bf-b8b1b6b1aea0',
          featureName: 'Equipment Reallocation',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1b28aa6e-b161-4141-8f44-cb39b0f82197',
          featureName: 'Equipment Resource Hyperlink',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f64cce1f-da87-4e8a-8309-5decb2728081',
          featureName: 'Equipment Search',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'eb53e617-3599-486b-9531-cf979c12e4dd',
          featureName: 'Equipment Search Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e949dc36-d5c4-4403-b673-b305b4c575d3',
          featureName: 'Equipment Usage',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a9b45b69-7dbb-4c9d-8a7b-fcfb91f28564',
          featureName: 'Equipment Usage Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2292ee39-4a43-45b4-8621-dca516d502a7',
          featureName: 'Bulk Edit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5544b91b-72aa-43af-aa1c-2005b752680b',
          featureName: 'Calibrations Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3c44e3ed-6828-4c30-8a4a-e749c5303bae',
          featureName: 'Equipment Location History Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ca683804-eb0b-4731-9b82-c9f190e7f299',
          featureName: 'Equipment Notes Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '30da4fb4-0ab5-4e8d-beb0-2242ce7ebcd3',
          featureName: 'Current Equipment Request Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a00b523d-1adc-4316-a031-2b15c146ac44',
          featureName: 'Equipment Resources Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'dff7a955-7b85-4a9b-aa41-8f69069c1aeb',
          featureName: 'Fixed Asset History Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '50b3e17a-9218-444d-8db3-3091793bf004',
          featureName: 'Info Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a8a649c2-e07d-4196-8ea0-d21c74663027',
          featureName: 'Inspection Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b1286b03-138d-4e09-a866-a37cc1615998',
          featureName: 'Job History Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'edff4f4d-5535-4140-bb59-1b63d9340b7e',
          featureName: 'Mechanic Notes Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c0013e04-5e46-4e2d-ac41-fbe472d1c900',
          featureName: 'Meters Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b5f59e15-b7dc-4918-8626-5ddcc1f48935',
          featureName: 'Ownership Info Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '42c7fa02-772a-450a-bfd0-4311ab99e817',
          featureName: 'Rental Release Info Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '75e0ae00-b232-49ea-8cda-0ae64e3df7c8',
          featureName: 'Schedule Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b1a11ed7-2e96-4909-a195-5a3810c3d1dc',
          featureName: 'Foreman Allocation Sheet',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5690c19e-3305-4982-bc2c-22e98a5bfea1',
          featureName: 'Can Move To Onsite',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '19827c02-a033-4bd0-97e2-66f7da0b8351',
          featureName: 'Can Override Labor Type',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '49bd7f11-9d95-4c28-b912-4c620bdb796f',
          featureName: 'Foreman Crews Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '03d24ea5-da82-4ab6-b9db-24842baf4ddd',
          featureName: 'Foreman Crews Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5ddcf063-f447-40c3-9ea7-3f753e54b50d',
          featureName: 'Foreman Mass Release',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9ee3f664-850c-4271-80ae-bc6604fef76b',
          featureName: 'Labor Type Bulk Edit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a08100dc-cb89-42e3-acd8-e391ae27408a',
          featureName: 'Labor Type Setup',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'aacaa3e4-215d-4f70-9c9c-55a80ad8e01a',
          featureName: 'Labor Type Setup Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5c3b9a83-69d3-47e5-a499-a9e347fcc8d8',
          featureName: 'Labor Type Setup History',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '18981789-9d10-4b02-92e3-4b2bffbbca92',
          featureName: 'Help Documents',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b62974b9-2108-4b89-8b38-b9e0128f6c9d',
          featureName: 'Tooltips',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bea227a0-a7bb-4474-b60d-20a8bdfd9bc0',
          featureName: 'Walkthroughs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f499dcfb-577b-4f41-b4bd-89101a80f570',
          featureName: 'AssignToOtherJobs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e3524248-0c57-4a76-8a90-45f8524ff43e',
          featureName: 'Can Edit Overflow',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f8f2b13c-dfb5-499d-b83c-b485888bb965',
          featureName: 'Training subtasks groups',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8b25b944-18fa-4b46-89d7-62f818054f3b',
          featureName: 'OCR Trainings',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f3cbd1a4-f4e2-4cd3-bb84-3f3d47b105bb',
          featureName: 'Safety Time',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b09abd77-68af-4c0c-9771-016e83f62553',
          featureName: 'Training Expirations',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3ec8cae6-b4b4-48a8-a6b2-cd65ff018257',
          featureName: 'Mileage Rates Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '763819c3-36bb-44d6-9fb0-7b5c05e0d011',
          featureName: 'Mileage Rates Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd09b89ee-28e1-4201-b174-7c640a42e998',
          featureName: 'My Team',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4ea405e7-6d30-4d21-af18-030a662cec3b',
          featureName: 'Can See Admin Expertise Areas',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2b827952-b67c-4f89-997f-1a7a4bd39610',
          featureName: 'Can See Admin Plants',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '32d5e933-6255-42e5-8208-d130bee5cee2',
          featureName: 'Can See Admin Prospective Jobs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '043a189b-623b-4208-995b-46850c937ef0',
          featureName: 'Can See Employees Around Plant',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '93e8f547-bad0-48e5-96d4-f4ef7ae8db5a',
          featureName: 'Can See Equipment Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '988957dc-87d4-4620-b441-586630e95a10',
          featureName: 'Can See Equipment Resources',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'aac24c73-ba34-42f4-b880-4a74a8fbad45',
          featureName: 'Can See Foreman Crews',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '00aceadf-e05b-4efa-b79e-f10c4a47b093',
          featureName: 'Can See Reports',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '958e410f-4e8c-4a5e-ab95-03063fdb0fa4',
          featureName: 'Can See Sync Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e3ce1dfa-52a6-407e-b9fd-f350ff3a69cb',
          featureName: 'Parent Customers Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a000e0b7-b7b6-4ffe-80e4-666a4fdf5266',
          featureName: 'Pay Sequence Rules Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '482d0f5b-d0fd-4368-9098-7b406211ee54',
          featureName: 'Pay Sequence Rules Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e506272f-7388-47d3-b45d-01d28b7c6f54',
          featureName: 'Pay Sequences Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6bdad9fd-3081-444a-aa70-61d8cddcafff',
          featureName: 'Pay Sequences Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '18d0b730-5a85-44b1-919a-2122186b3dac',
          featureName: 'Report Categories Assignment',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '08c3545e-ca1d-4933-8a2b-3016f37fc9e5',
          featureName: 'Report Categories Control',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4c1cd485-e7c4-415d-aa55-9d14d5c0ad40',
          featureName: 'Reports Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8d7381d1-b847-410b-b2e0-e2d6218d4df1',
          featureName: 'Reports Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e23b59fa-6685-439a-9180-995a9c5c8bf1',
          featureName: 'Report Sparta Roles Assignment',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '02b9cf66-0179-4d62-a660-5590114dda6d',
          featureName: 'Report Sync',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0f56421f-f3ff-4bac-b178-b3b68d18e239',
          featureName: 'Security Roles',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4dc2abd1-5857-43b8-97f5-725f9a852134',
          featureName: 'Cost Detail',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '857ef57a-8d72-4916-9d57-93b099c5fbe1',
          featureName: 'Custom Export',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8609e631-e61c-400b-ae62-faf03da79ebb',
          featureName: 'Dispatch Statuses',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8198303d-ad0a-42ca-9619-6aa63c8f53f6',
          featureName: 'Employee Dispatch',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1984c542-e1eb-4dde-af2d-454f85e7215a',
          featureName: 'Equipment Dispatch',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1026b11c-d973-4bb6-bdcd-cac1b747e60b',
          featureName: 'Equipment Search',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '68ee32b8-56eb-4caf-b8ad-2a7975ef2488',
          featureName: 'Equipment Usage',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7c72d395-7c15-4fc0-aaff-910e0c405ce2',
          featureName: 'Exports',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2016b5f9-3cac-40f7-bcba-e798f243599d',
          featureName: 'Foreman Crews',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'afab2877-85f6-40cb-b2eb-514507b900de',
          featureName: 'Job Requirements',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '81c64e9f-88e4-45f5-85a1-1cfbfccba54c',
          featureName: 'Labor Type Setup',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '903206f4-188b-414f-a907-96b19b951a67',
          featureName: 'Mileage Rates',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fa502b3b-bcf9-499d-b15d-ad74bcaf1f7b',
          featureName: 'Parent Customer',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '088e05ed-4a96-4a05-adfc-f50442f6237f',
          featureName: 'Parent Facility',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c368bc5b-2599-47c5-bd83-40ee0ba9914a',
          featureName: 'Pay Sequences',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '96b2ebdc-2239-4d7a-8118-c52faffac407',
          featureName: 'Plants',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '391a1fbd-233d-4704-b316-82bda764ead6',
          featureName: 'Reports',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'aac74d15-2900-41ac-8a33-ec7474976f89',
          featureName: 'Sync',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a24efa72-252a-4164-bc5f-03de27f64b47',
          featureName: 'Time In / Time Out',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9d135474-fc73-4741-8f3d-db0fc707c530',
          featureName: 'Timekeeping',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9ddcddf2-d84b-4691-8d62-9c3c0c81bfa9',
          featureName: 'Timekeeping Checklist',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9ce2c871-45c5-4145-8828-6e87b62ae3f3',
          featureName: 'Timekeeping Search',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fab0a72a-63b1-49bb-88b2-4db299e19d39',
          featureName: 'Time Sheet',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '214ab865-e685-4265-8a04-cd9131946653',
          featureName: 'Work Orders',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0b64de56-39cc-4b43-bfbf-fbd1ee918a9a',
          featureName: 'Equipment Corrections Audit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8b00ae31-4188-424d-9cf4-29b88f087b3b',
          featureName: 'Foreman Equipment Import',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9aa08850-dc62-4ccf-99a0-475416d8978e',
          featureName: 'Foreman Time Import',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd032dc05-a9de-4494-b94e-a29636d7788d',
          featureName: 'Foreman Time Manager',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9e4380ed-ded1-4dac-a564-70d6836c8073',
          featureName: 'Timekeeping Corrections Audit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5c7d1b81-7204-4342-89af-dbae3b658609',
          featureName: 'Save default tableviews',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c35f48e9-b6be-4b28-a071-9f0509af92f9',
          featureName: 'Set Dispatch Status',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '642ee98f-83dc-49a5-9e4b-7059bdb33bdf',
          featureName: 'Sync Sparta Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '93de1df3-3993-4413-b1bd-ba38ef4e2985',
          featureName: '14 Day Extended Un-ROF',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a5f3f69c-92eb-4d3b-a44a-99d8dbf7abcd',
          featureName: 'Badge Scan',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e627a60e-fcb2-4a3a-a255-ebc0ebef4957',
          featureName: 'Can Apply Step Up',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ba2a8c92-afd2-4acf-9f36-3cf60d851b15',
          featureName: 'Can Move To Onsite',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'cc7e0097-da85-4a4f-9984-ab4fb80c053d',
          featureName: 'Can ROF',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '44eaf8a5-3f66-4111-8db1-8a965481c49a',
          featureName: 'Can See Bill Rates',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1cc6d5c4-931e-4fa0-892a-a63ae42ea558',
          featureName: 'Can See Pay Rates',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b6eff7d3-73c1-4c5e-84aa-39c93b8a1427',
          featureName: 'Corrections Audit Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '247eae97-5267-489c-81db-58a886e5ae19',
          featureName: 'Corrections Audit Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ffadb5d1-3d0b-4f33-a7e9-d25533b29890',
          featureName: 'Create Work Order',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1937f064-069f-4a24-a3f4-f1a5966a2720',
          featureName: 'Export Over VP API',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e245bb10-26b5-48ac-b5ef-393d56c8c8e7',
          featureName: 'Export Timesheet Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '45408308-b505-4aa7-82a8-14943f0439e5',
          featureName: 'Export Timesheet Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f52a5f21-aee3-46ef-873b-b19c83344b1e',
          featureName: 'Key Time 3 Days After ROF Date',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '425d9cdf-7fb7-4eba-bfeb-872d0a4bee05',
          featureName: 'Reallocate Between Jobs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1b44ea85-0925-4bf4-a123-c655b9a22bbb',
          featureName: 'ROF Watch List Power BI',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8bcfc091-0f14-41f3-a117-633bba98df6e',
          featureName: 'Splitting Per Diem',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fda18420-68cf-4016-883a-0ae8e11c18aa',
          featureName: 'Time In/Out By Employee Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c077056c-8e7c-4c6f-be0b-97eb459c1317',
          featureName: 'Time In/Out By Job Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a121ad86-6428-4ef7-bcc1-239c9d584b4f',
          featureName: 'Time In/Out Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'aaf7733d-fec6-444a-9ce8-282edd090025',
          featureName: 'Timekeeping Checklist',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3aee7db5-6aac-4d79-b010-0ffdbe280e9c',
          featureName: 'Timekeeping Checklist Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5d4debbc-06a8-4c38-b2f9-e9374e0605f9',
          featureName: 'Timekeeping Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a3fef5bb-50d9-4360-9cf4-64078c514c58',
          featureName: 'Timekeeping Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '800d4cf4-8670-4b11-98dd-18bb7615c03a',
          featureName: 'Timekeeping Reallocation',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f1e837f5-0f30-444b-8661-cc39ba418f6e',
          featureName: 'Timekeeping Search',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '111111dc-3847-4439-af6c-4d4850209364',
          featureName: 'Timekeeping Search Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'df439b3b-5bb3-4794-9c71-066a539afbb2',
          featureName: 'Timesheet Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '412c5605-37a4-4df1-8019-fa4e30489c77',
          featureName: 'Timesheet Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c4b388e2-0dcb-4c25-8c20-aa2cd143d91c',
          featureName: 'NativeChat Access',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9282ffee-c7ee-4959-a311-fde3fed4dfa7',
          featureName: 'Work Orders Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7c4c62e7-15f3-4b36-ac32-5b9b4c551d32',
          featureName: 'Work Orders Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '47a7a5c7-41f8-4725-97cc-e7a16e6d63f8',
          featureName: 'Map_Analytics',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0fa70f6b-68e6-4445-bc03-636838d53acc',
          featureName: 'Requisition',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f8dade08-a531-4a7d-bc5b-5dac831b4106',
          featureName: 'Badge Clerk Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e3094b26-f70e-4e46-b42c-04602ff11a88',
          featureName: 'Class Administration Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ea1e4372-454c-4d10-89ac-2daeba8f7aee',
          featureName: 'Class Management Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7c8545c0-930e-4124-8b57-38c69d666770',
          featureName: 'Address Change Request Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a7d3910f-dfc1-4ca6-af5e-3718f3b3f294',
          featureName: 'Compliance Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '60f4300a-80d6-40e8-bc01-98337cfcf07e',
          featureName: 'Compliance Workload',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '615d4560-2e04-4bd6-9108-df75e202ebfc',
          featureName: 'Compliance Transfer Workload',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7495e483-6394-4249-8b36-0031258a4657',
          featureName: 'DISA Roster Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '84837958-7f5c-4300-90ff-e855a4e83c37',
          featureName: 'DISA Roster Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '43766c56-a93c-43af-9e52-d890d40b06cf',
          featureName: 'Active Status',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '11eb2310-3b72-4150-a33b-3415eb331011',
          featureName: 'Bill Rates',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd3c1ef36-337c-4d50-bbed-6f5e47171c37',
          featureName: 'Dispatch Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'df436867-34f0-4fb8-baa6-927a2fd9ddce',
          featureName: 'Dispatch Docs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a9c259a1-84c6-4e21-b712-504144f707f6',
          featureName: 'Edit Class/Craft/PR Details',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3ae60853-5175-418b-8197-679f87758589',
          featureName: 'Edit Start Date',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8831222c-3ffa-4da1-93b6-517fde706ccd',
          featureName: 'Edit Wage',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'be3ba390-8864-4556-9567-4a1f8842813e',
          featureName: 'Hard Dispatch',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3edb8b88-e6ba-4abe-811c-171e8fac6e88',
          featureName: 'Mileage',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '40119dca-3eb1-495e-a41e-c1be6130da65',
          featureName: 'Multi Edit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd332180f-12ca-4a97-ac94-06590db376cc',
          featureName: 'Pay Columns (non-wage)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0da79dc0-07e7-4c88-bc09-70be2dc8c403',
          featureName: 'PerDiem Docs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4e695061-c50a-48e7-b90c-8e83a67300eb',
          featureName: 'ROF Date',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3ce951e7-31d2-4f0f-8560-62ae4f31f674',
          featureName: 'Basic Edit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e04d2119-be90-4261-9ead-dab82b73c02f',
          featureName: 'Change CAUTION status',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c9e8cbe5-4f0d-48ec-8843-c403ef75b549',
          featureName: 'Change DISPATCHED status',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1f8f75c2-c1a3-4d24-a297-6eaab2415ddf',
          featureName: 'Save DECLINED from HOLD',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0618c062-a9ac-424f-b3ce-3df5946c11e7',
          featureName: 'Save DECLINED from REQUESTED',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1db8db5b-0a56-4936-bb9a-8a83bb96a102',
          featureName: 'Save DECLINED from WRONG NUMBER LISTED',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c52df092-c9e9-4020-ba90-322bb19b1e31',
          featureName: 'Save HOLD from REQUESTED',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd40ade1b-1a2f-4a19-971a-3e6ad47a773b',
          featureName: 'Save POSITION CANCELED from HOLD',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '963b699d-7b0b-4a0c-9322-f0fbc5c7e20e',
          featureName: 'Save REQUESTED from HOLD',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a9e36455-4e10-4dd1-98f7-0f2eeff4a7ee',
          featureName: 'Save REQUESTED/HOLD from POSITION CANCELED',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c91b6a1a-aab6-4f9e-b6c2-002a283d7a15',
          featureName: 'Save REQUESTED from WRONG NUMBER LISTED',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3b104190-23ab-41ce-a4ab-bdf1502dda6b',
          featureName: 'Document Info',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '84136cfb-00a1-48f9-997e-6a4bde418da9',
          featureName: 'Requisition',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5db877f8-6134-4842-95b0-fdf78541586f',
          featureName: 'Absorb Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3cc0fdb7-1a49-4a1a-8e71-79c467b753d2',
          featureName: 'Attachments Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd3b68d07-c883-44e9-b5c8-18c2ba95e6a6',
          featureName: 'Authentication Data',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3d7405f6-6050-4ff2-8b0f-ee9c489fa952',
          featureName: 'Background Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '36776953-4d84-489e-a0fb-2166696bd13d',
          featureName: 'Background Tab Attachments (Address Trace) ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a07aefe6-553f-45c3-a496-2af29533b65f',
          featureName: 'Background Tab Attachments (Can View)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bb13a993-78ea-4564-8715-03358f53e7f7',
          featureName: 'Benefits Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e8495c54-1a55-4e33-9577-018b5dd4f743',
          featureName: 'Benefits Tab - Employee Type / Job Category',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3d4729e7-4d64-47c8-9344-6c022441a575',
          featureName: 'Cert Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5fb85dca-f07a-4ab0-b6f4-ea8ed48671a1',
          featureName: 'Chat Logs Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0c28c43b-be9b-4a55-8800-4258b422a1af',
          featureName: 'Edit Email',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2a53d1ea-27f4-4163-84e0-a7b2ed3e880f',
          featureName: 'Emergency Contacts Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4aa607b7-2024-4b44-ae01-40015b5ab8c5',
          featureName: 'Employee Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd7434746-d639-4235-a0f0-773f9fb0e32c',
          featureName: 'Employee Profile Component',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '978c132c-846f-4178-aea4-a2bfacb1af27',
          featureName: 'Employee Packet Documents Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ac38d465-90c2-495c-9fa6-478b005a3330',
          featureName: 'Employee Profile HRREF',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '26173290-d364-4ba6-8252-3a8d465715e0',
          featureName: 'Employees Tab SSN column',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ce114872-e24e-4c61-be07-41ba2e94194b',
          featureName: 'Employment Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1957c780-ccb2-4a92-b401-43f56209cba4',
          featureName: 'Employment Tab - Do Not Rehire',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0ae3e232-48ad-429c-879b-a29996265248',
          featureName: 'Evaluations Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a231b66b-80be-419a-b487-168dccc92100',
          featureName: 'FIT Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ef4ad7fd-d2a5-43ee-9f4c-a46708731d61',
          featureName: 'I9 Status',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3d5cfc0b-6cb3-4e59-a534-5e636e276a4a',
          featureName: 'Identification Documents Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7250027c-01d1-42bf-9ec8-72b11a926992',
          featureName: 'Identification Documents Tab (Attachments)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1315a0ab-0bc5-46cf-a8a2-d763fb6f45c1',
          featureName: 'Info Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6bce8c23-8d0b-417f-8a33-88c845544a9c',
          featureName: 'Info Tab - Edit Cell Phone only',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9dc6a615-a9fe-43ad-810b-893064477af9',
          featureName: 'Job History Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '353ba3f0-085f-43db-8b90-f2248a87db27',
          featureName: 'Man Power Req History Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4f545685-fa50-4bf0-9f6e-d479b3bc49c5',
          featureName: 'Packet Documents View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '29bfdc65-886b-4658-8658-a2ec6649d866',
          featureName: 'Pay Stubs Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '112b8c67-35d1-4a00-b0c6-49ec65454b70',
          featureName: 'Per Diem Documents Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'aa382429-7363-416e-9de8-b91de66aaf42',
          featureName: 'Position Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '110c5847-7432-4cbf-91f0-7cee0a54feaa',
          featureName: 'Rehire Status',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '99fb5a4c-ed87-49ed-b83e-88c27678811d',
          featureName: 'Rehire Status - Medical Release Required',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b599f3c6-7567-49ad-904c-5b41e730aea9',
          featureName: 'ROF Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b697bec1-9df6-44fc-9aa2-53d9c452d61c',
          featureName: 'Safety Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f74db5e1-b1fc-41af-9dec-0919ffe05b24',
          featureName: 'HR Resources Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd46ed4f3-898b-4ef5-a42c-72d9f48a0975',
          featureName: 'Admin Approve',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8c3662fc-50d4-49f6-b46c-289382ada8fc',
          featureName: 'Job Requirements Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2bd2b315-30b7-4dde-8885-ba12d0bbedb3',
          featureName: 'Job Requirements Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7c081d5e-82a4-4f47-b9b4-39184fb7525a',
          featureName: 'Lodging Administration',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b6f4a803-6e29-4f40-824f-4922c28507ec',
          featureName: 'Lodging Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f27f439d-96e8-4373-845e-98cbfb809c46',
          featureName: 'Lodging Grid',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4faa0a29-8d56-4935-90fb-df4401c2d579',
          featureName: 'Loding and Events API',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '17a5d498-75f6-40e9-bf8e-8d5dcb6f96d9',
          featureName: 'Allow Dispatch of 12 Month or more of Inactivity',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7c0e1e41-2188-4e4c-b25a-0aaea2ecfb43',
          featureName: 'Assign NonRehirable',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '34c1be7a-6dc9-41ed-a5e0-9428f1952eaa',
          featureName: 'Employee Notes',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c5957c33-c59f-40bd-9454-1ebc675e7c9c',
          featureName: 'Force Dispatch',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8dabca72-751d-46fe-996b-878260424e97',
          featureName: 'Job Requirements',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '33e5096d-eca8-4218-9f3b-d0cd9abd627a',
          featureName: 'HR Files',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '245cbf8b-4cab-40ac-a5d8-4ec8d118cbf9',
          featureName: 'Can See Available Jobs Recruiter',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '196a28ce-0a0f-44ce-9935-1e062d0b33d7',
          featureName: 'Can See Badge Clerk Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '79d411c0-1e7f-44aa-a61a-0ec90416931c',
          featureName: 'Can See Class Administration',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2e735857-0820-4363-a8f0-aff1155ad08c',
          featureName: 'Can See Class Management',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '72e6c6c2-c9d1-4da2-bb1f-36cfd9c862ae',
          featureName: 'Can See Compliance Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '128d5b6b-5011-4da7-8d3c-8a26c8a284b7',
          featureName: 'Can See Disa Roster',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5c29a753-ac43-41b9-9f4e-f8d5481b2fb1',
          featureName: 'Can See Dispatch Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '177828aa-07d1-47aa-b05f-421dbf35f02d',
          featureName: 'Can See Employee Jobs List',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f930dbd4-b202-4b8d-9647-9f9215688b69',
          featureName: 'Can See Employees',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4eb7e2db-016d-4761-8a73-7d16f75a335c',
          featureName: 'Can See My Profile Info Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '88f80148-68eb-446c-a6d5-81d584e5ab75',
          featureName: 'Can See Per Diem Audit Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'aec5595d-8ff8-4809-b9b4-1853b0333a98',
          featureName: 'Can See Project Manager Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '26f8d0f0-d382-415a-8b21-4f74c3ac4ba1',
          featureName: 'Can See Prospects',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e0bc7dd2-f3f2-4d58-a1ba-a60cf26c05cc',
          featureName: 'Can See Recruiter Dashboard ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'da426305-9aca-42df-ba69-97645c6f6afa',
          featureName: 'Parent Customers Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b60150fe-588a-4e8c-a994-26ec6c881597',
          featureName: 'Parent Facilities Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '88902048-fde9-4d4b-a336-341f9e8d3237',
          featureName: 'Parent Facilities Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2ea08966-55b8-48dc-891b-b19efa89437c',
          featureName: 'Job Popup',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '802fc251-18c0-4431-9d39-ccf342b6f5a1',
          featureName: 'Per Diem Approval',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '398f5208-8c2f-43a1-a100-d97adb7a3ffe',
          featureName: 'Per Diem Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '961fe424-c7e7-4c82-8f61-e24d67a6f2dc',
          featureName: 'Plants Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '053c20c5-477d-421d-96cd-01b4f0a445a2',
          featureName: 'Plants Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9a496878-416b-4863-9006-24a41f8cb82b',
          featureName: 'Project Manager Advance ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a0780247-d98f-4ed8-b624-dc1c973d79de',
          featureName: 'Project Manager Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f9e09c14-0c0b-4467-a29a-8796de54c944',
          featureName: 'Project Manager Dashboard Info',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'eaee380e-ec5c-4fa8-802d-c2c2f485408a',
          featureName: 'Project Manager Equipment Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a532c364-e88e-4b19-8332-8862cad2c174',
          featureName: 'Prospective Jobs Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '093fc505-97f1-470b-b4c1-357c41f51651',
          featureName: 'Prospective Jobs Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '32b8caf8-6d3c-4953-8433-741971eed6f6',
          featureName: 'Packet Registration',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '92bf9b3d-94f1-404f-a550-fff3c489f132',
          featureName: 'Prospect Info',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c55acbb5-f867-4721-8beb-214b50f7b12b',
          featureName: 'Prospects Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3e8aa3ff-09fb-4cf3-bfca-7026dda6c6fb',
          featureName: 'Bulk Edit Recruiter',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'df3e5b0d-2e97-4d03-95c8-25e373f4d168',
          featureName: 'Recruiter Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'cf69d556-fdb6-49ae-bb6f-3c072301c054',
          featureName: 'Recruiter Scorecard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '623e1ccc-d1ae-4708-8fbf-a60b412f5859',
          featureName: 'Recruiter Workload',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '64874bc8-4acd-4532-9939-894f22307bdf',
          featureName: 'Transfer Workload',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ef15fdfd-3222-4c44-a9c7-f21f31e93ff3',
          featureName: 'Employee Jobs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c4e3e684-0c69-4000-b6a9-67a2bfda4e09',
          featureName: 'Chat Logs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'adc5f3a9-57f9-411a-a252-2b5f7ed92e2a',
          featureName: 'Foreman Time Entry',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4fa4fe12-58a5-4333-9e3a-34a13d44fd0e',
          featureName: 'Basic Access',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd347d0f8-241a-4b9e-8ac2-cf67a964dcc1',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a1e61265-7606-487e-a1a4-aff1324e0287',
          featureName: 'Badge In Out Kiosk',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0e42ec5f-e072-49bb-9c2a-3f4bd694851a',
          featureName: 'Geocode Admin',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '79b09299-c668-4fb2-a611-fd64a4f79880',
          featureName: 'Jobs Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8685acce-ee82-41bc-8217-f68be6715819',
          featureName: 'Onboarding Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c4d7fff1-2f59-419d-a1c2-c7981f255f18',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ea2216eb-f48f-4162-999e-85532311be11',
          featureName: 'Individual Time Entry',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6ced190d-5bc9-47bd-85f0-207f555bf18f',
          featureName: 'View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1de11bf3-2047-4787-87b6-378827618fe5',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4c508271-2f87-44db-a0bf-0b3b2f2b3575',
          featureName: 'Employee Performance Review',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ab4c64c8-54eb-4778-90d1-81a2702ff28c',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6ff6a180-897e-4ff8-b13f-9c02adf6d64f',
          featureName: 'Employee Performance Review',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '83449eb2-e023-4257-93f6-b17462280dd9',
          featureName: 'HR Operations',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '46abacba-1a5d-450c-b26a-cc87dc747666',
          featureName: 'Backorders Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '50cf867d-db01-4444-82da-1a08373564f5',
          featureName: 'Customers Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '62cb3d92-3f8b-420f-ba52-26a9023df6d5',
          featureName: 'Diagram Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ee464831-427f-4371-a43d-cbfef9fff64b',
          featureName: 'Dock Log Custom Views',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b6e6e79e-0f44-49f8-87af-f71721b69fe2',
          featureName: 'View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '00e23279-ab4f-45f2-8ac4-0511955760b9',
          featureName: 'Add/Edit Sub Location',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7b51f32c-3eb3-4ce3-97a9-b6e3840683d0',
          featureName: 'Can See Prices',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1de05a2e-a5bf-44dc-90cc-a437039b5638',
          featureName: 'Dashboard Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1b6b27bc-6c6b-46e5-a5b8-b76ec0cee44a',
          featureName: 'Inventory History',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '366138f8-8b5d-4366-973a-33872285772d',
          featureName: 'Inventory Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ce2876e6-d827-493d-a415-3da285d22009',
          featureName: 'Material Notes',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5459686f-5c36-41f9-8720-33eff93b94af',
          featureName: 'Create sublocations',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '605cfa4d-2899-4c84-b8b5-fec348169cc6',
          featureName: 'Label Maker Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '15160e1a-865f-4425-b3c4-12ccad4e27be',
          featureName: 'Dock Log Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '85de2587-d410-4545-a3b1-724f92cd8425',
          featureName: 'Inventory Management',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1a5f071f-be02-42dd-a61e-07f1e728ee5a',
          featureName: 'materialphotos',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '98a575d8-68fb-4a99-8e1c-6bc5f693036d',
          featureName: 'Transfer Stock and Print',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '07e48d03-10bc-4027-8ae9-8f5de7f8f480',
          featureName: 'Create Quote',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ef504702-c2f3-4819-b847-a24c99ba69c3',
          featureName: 'Edit Order',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c2a984c4-b174-4814-bb29-123407ea1980',
          featureName: 'Fulfill',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f09a59c0-48f1-47a2-8acc-09ccef81e649',
          featureName: 'Order Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4959c913-fd5e-41c2-9325-fa8e9b4597b3',
          featureName: 'Quote to Sales Order',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e7963bf2-a23c-465c-bf8a-200cb98893c3',
          featureName: 'All Reports',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '83f09308-64ef-4c12-9052-cb3735ed8726',
          featureName: 'MaterialVPUpdateModal',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1790923d-c2d9-498d-b604-955ff2ff391c',
          featureName: 'Vendor Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9f27d14a-12f7-4a8a-af49-8a65c4465a89',
          featureName: 'Accounts Page1',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8f2cffc4-78f0-47d3-8b66-eaca65e46b86',
          featureName: 'Accounts Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'dee92528-0489-4d49-9d94-982f86bf93bc',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'be728787-c6cc-4794-9539-13fea25c2f28',
          featureName: 'BD Activity Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '73772909-82ed-44ee-96fa-c9cbda965e90',
          featureName: 'View BD Team Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '47787ac8-8a6a-4462-aae2-43849186ed18',
          featureName: 'Contact Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '97c49f7c-2d65-4f4c-9988-daddc4a833f2',
          featureName: 'Estimate Builder Admin',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9160fe38-70a2-4b3e-b8c6-c671e1cd3ceb',
          featureName: 'Estimate Builder Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '17456b1a-f340-4143-8a29-65a2c69d4f93',
          featureName: 'Fleet Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '063db9b1-a2a0-4674-b03e-9bebb2f4547a',
          featureName: 'Jobs Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2a11cfa4-4722-4c4b-976a-e1dfe1f59746',
          featureName: 'Manpower Needs Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f995ad13-010c-443a-8ecb-4cefe824d8eb',
          featureName: 'Quote Log Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e7bd82c3-3443-4af0-93fd-8dd09a1b2b0f',
          featureName: 'Activities',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1e9cccd3-de11-42fb-8f84-d7310b1f11ce',
          featureName: 'Opportunities Dashboard Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e80268ec-f39c-46d8-a8e3-1ec854af9346',
          featureName: 'Oppotunities Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '90230e6a-0798-44a6-bf60-85fec8367bf0',
          featureName: 'reportspage',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'de929645-0322-4f18-acf1-134c30ff4909',
          featureName: 'Bid Review Date',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a3f1e9a8-ab09-4b05-87b9-d2040c593b72',
          featureName: 'Create Quote',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c2687395-7719-4c1b-9740-033429cd2a56',
          featureName: 'Edit Dead Quote',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4c4a6112-797e-4c70-8fc1-a600b51ab022',
          featureName: 'Edit Quote',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '784e7ec7-e3cb-4271-808a-f591f33bbe42',
          featureName: 'Export to Excel',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '219dcf76-5510-41d0-a192-8982531d5ac3',
          featureName: 'Grid Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9a87e7d9-38c4-4714-8b46-f3fa58c40509',
          featureName: 'Quote Log Attachments',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fe4191f1-ea1b-4231-aa54-dfb87d444f19',
          featureName: 'Quote Log Attachments Delete',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7118595e-8507-4fa7-9235-5093bebddff8',
          featureName: 'Quote Log Revisions',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e4b256c4-bf28-4c5a-8ff3-5c10eedec072',
          featureName: 'Quote Log All Reports',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c8679b0f-d095-4204-8c38-0e22f1ac2889',
          featureName: 'Revenue Stream Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9e2efd3b-202c-48fd-9126-3fa8a905ecee',
          featureName: 'Always See Plant Dropdown',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bca07a16-c940-4d1d-97f9-d05235422ed1',
          featureName: 'Approver',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '37382a6b-6f35-4c23-895a-d583e9424125',
          featureName: 'companyscopeoverride',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a3fcc1f4-4ace-45f2-8aac-eb0899790d3a',
          featureName: 'Convert Quote to SRF Job',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5c418dee-1e01-4d14-92ee-73ea20a9e231',
          featureName: 'Convert SRF Job to Job',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ace2af75-a622-4404-a3b3-d611ede72c89',
          featureName: 'Convert SRF Quote to Quote',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0cdacbb9-a464-4cf2-bb79-d124e7a41e59',
          featureName: 'Prospect Approve Conversion',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '672c7534-7ab4-4c2b-bb82-a6d003c430f9',
          featureName: 'SRF VP Job Create Gate',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '510cbc0a-a675-4d2c-8511-5727f6f343c6',
          featureName: 'SRF Notification Admin',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '46ead6f5-37d8-4256-9551-b1ff0cc5d3f6',
          featureName: 'View Service Request',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2e8ab756-ef5d-44b0-8bc0-54635f76c324',
          featureName: 'OM Webjob Integration',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '42121ea4-c1e0-48be-90ea-1ed6e375135a',
          featureName: 'Base Revenue Codes',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f49f0565-f6f6-4e47-b00b-02863ad010aa',
          featureName: 'Contract Sections',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'cea6eb95-bb41-4564-9700-60bc316d25b6',
          featureName: 'Divisions',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '875f807f-8233-4686-95fc-9b458ee5302c',
          featureName: 'Equipment',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f07287c0-f442-4035-bac1-c0d2ab267f73',
          featureName: 'Equipment Notes',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1755df0c-1331-4117-84ed-7dda007f24fd',
          featureName: 'Revenue Codes',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9339db30-bafa-4077-b6a5-cd7cf2a0f022',
          featureName: 'UnitsOfMeasure',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '23bfbc5a-68ec-4154-a60f-92228021cc2b',
          featureName: 'Contract Attachments',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'df8e33da-7bb8-427f-911f-0c5a6442c127',
          featureName: 'Contract Screen',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '569b578f-c65c-4a7f-8385-a348ab25f7ec',
          featureName: 'Contract Summary',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '54cf86a2-8b5a-4edd-9867-5cdf5ccf06db',
          featureName: 'Copy or Amend Contracts',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '05c08b0b-bee4-44b9-bfe5-32af74c3afdb',
          featureName: 'Create Contracts Custom Views',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bb52f0cd-5ccc-4461-abaf-50ff9204916f',
          featureName: 'JsonViewer',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '898b7f8b-5030-4774-90e6-d768f3e0ce11',
          featureName: 'Edit Equipment Base Rev Codes',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd7924641-9222-497f-8b55-8a8399d29fd5',
          featureName: 'Equipment Rev Code Column Visibility Toggle',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b1191b25-4af8-42d4-928b-69b83811806d',
          featureName: 'Rate Sheet Attachments',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8d0bbd20-9b80-4b3a-87c8-35ce95a072ea',
          featureName: 'Rate Sheets',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'beb9fd7f-f77f-4a67-a34e-2626b40af9bd',
          featureName: 'Version Rate Sheets',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'dc04bd41-b3a1-492c-ba87-b6995126b10e',
          featureName: 'Contract Selection Screen',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bcfe8cbb-85ce-4d5c-80b5-330b3cb42c0f',
          featureName: 'Rate Sheet Data Entry Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9961f0c2-2476-4839-8a3d-3adebd7f62ae',
          featureName: 'Rate Sheet Custom Columns',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7dace562-e055-4fe0-949a-0a048297b9c1',
          featureName: 'Rate Sheet Equipment Rates',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '624531a9-0284-41fe-8c5b-5cf9cc01d8e3',
          featureName: 'Rate Sheet Selection',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b6358fb1-8454-48c9-bc22-24da3b5e38d7',
          featureName: 'Rate Sheet Terms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7236a360-bad6-4aa4-8109-e5c31c43ce92',
          featureName: 'Wage Sheet Custom Columns',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f723ccb6-4b26-454e-b79c-65534dfdb113',
          featureName: 'Wage Sheet Data Entry Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3cee13aa-9905-42ce-a1ff-ae7b414da383',
          featureName: 'Wage Sheet Selection',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7e01331d-ad78-4fe3-b0a2-7060c7148e61',
          featureName: 'Wage Sheet Terms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ed87133e-805f-417c-a27a-ad7a5eeaefc7',
          featureName: 'LRCS Report',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3a94b81f-ce8c-4e46-806a-404e2db86bb2',
          featureName: 'Copy Wage Sheets',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'adbbf3ab-40a1-47b5-8aed-05db88aa48ca',
          featureName: 'Version Wage Sheets',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '38bbdbde-3d72-4ac2-8e4d-57c57b673788',
          featureName: 'Wage Sheets',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0e0e8de7-0627-4478-bd81-ed940b44bda2',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'be184318-759b-42be-a74f-72808b19a362',
          featureName: 'Class Administration Dashboard',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a060b9d8-b16c-4583-802b-757a799530a7',
          featureName: 'JsonViewerRA',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0bbde1df-108d-4679-a6ab-2be690f1940f',
          featureName: 'Mileage Multi Edit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c411345f-479f-4316-b296-e245bcd8463d',
          featureName: 'Prefilter Skill And OnBoarding Courses',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '67b47c42-3c55-47e5-8a56-dfd99c81daba',
          featureName: 'Employee Expertise',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b25c71af-7ff5-4aa2-9db1-2927139b43f7',
          featureName: 'Equipment Expertise',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3f56f47f-7b01-4e77-83e6-31532391fea2',
          featureName: 'ManPowerReqDetail Expertise',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '90b97697-c40e-42d2-aa34-4cfbb08a3d55',
          featureName: 'Performance Evaluation',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ae3d1507-cecd-4110-88a5-8efdaf93dd09',
          featureName: 'Trade Expertise',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '14a37b70-2863-4ba8-bb50-2ae020543615',
          featureName: 'Allow Use of Alive 5 for Chat Logs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5a94c97f-ec4a-4858-afee-5c8b025a74ad',
          featureName: 'Fleet Documents',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e8e5fd64-16c9-4cc2-888d-46d946e5b85b',
          featureName: 'Add Items to Count',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ed40f93a-2447-4839-85a4-b0971b436aa9',
          featureName: 'Adjust Billable',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '563f4264-ca28-484b-aa63-c0d2b9c971ac',
          featureName: 'Adjust count adjusted',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fcddb565-e240-47f2-9e16-b974facc761e',
          featureName: 'Adjust count recommended inventory level',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6846e36a-aa60-4680-b421-d18e017b08cf',
          featureName: 'Adjust Initial Count',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c2d60338-cd0b-433f-b236-dbb880726a84',
          featureName: 'Adjust ordered and received ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7777f3c6-80c1-40c3-9038-8984ac2e2765',
          featureName: 'Adjust pulled',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6bdb6845-b9b5-4178-b789-469993ddabc1',
          featureName: 'Admin Count',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'cae48cd3-6e25-4010-b7cd-d5b9445f0f4b',
          featureName: 'Can Access Mobile App',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0c61d785-0995-4068-b7d6-88f54c9b5cda',
          featureName: 'Create new count',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8564f18d-43c5-4d0c-b218-8bc5fe38dd59',
          featureName: 'Equipment Selection',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b0cc3236-1140-44ce-ae53-713877af10e3',
          featureName: 'Inventory Count Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '01f7679e-6351-447e-a394-85be4b488283',
          featureName: 'Remove Items from Count',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3e9a2ca8-6efd-45e9-8245-86c87622cbe0',
          featureName: 'Serial number and expiration date',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '13cf81e2-679d-44d2-ba66-a0e667b3853a',
          featureName: 'Demobilize Approved to Closed',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'cb240d0d-62bc-4c2b-8162-122c41959f8e',
          featureName: 'Demobilize Open from Demobilize Pull or Return',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '37724b7b-5965-436e-bad2-957143a9f4ae',
          featureName: 'Demobilize Open to Demobilize Pull or Return',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fce95c64-619f-44e0-89f0-665163a46e0f',
          featureName: 'Demobilize Pending from Demobilize Approved',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f4374f87-fbea-4fe0-919d-5b519844836b',
          featureName: 'Demobilize Pending to Demobilize Approved',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'eb61398d-0619-46a3-8afe-762b959c1b24',
          featureName: 'Demobilize Pull or Return from Demobilize Pending',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '000a4530-79b9-42de-906a-619f2eb15d61',
          featureName: 'Demobilize Pull or Return to Demobilize Pending',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f5d3e200-94c6-454e-9dc1-b3f4b21b4f39',
          featureName: 'Field Count Final Close from Demobilize Open',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5754d38a-0e85-4dea-bc9a-359732a489a2',
          featureName: 'Field Count Final Close to Demobilize Open',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '12453f72-1e11-49d9-ae16-8458db7a07b9',
          featureName: 'Field Count Final Open from Field Count Final Close',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fc7baa18-368b-4b13-a2a3-c20731e4d4f3',
          featureName: 'Field Count Final Open to Field Count Final Close',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ba13f939-aab5-4336-b16b-b6e05688bf9a',
          featureName: 'Field Count Initial Close from Field Count Final Open',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8e43a0e8-d28a-48fe-8359-0feace0b97eb',
          featureName: 'Field Count Initial Close to Field Count Final Open',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '37f27d21-f70d-4914-b46c-1cfd4b2307b6',
          featureName:
            'Field Count Initial Open from Field Count Initial Close',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '005e1f4b-7e2a-48d4-a90a-f827a410ae22',
          featureName: 'Field Count Initial Open to Field Count Initial Close',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3da6b694-ada8-4673-928e-9624be656560',
          featureName: 'Mobile Open from Mobile Pull or Return',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'df633c68-bdb5-4b2d-9c51-8ffc5385f7fe',
          featureName: 'Mobile Open to Mobile Pull or Return',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd762c67b-231e-4737-aa15-04c2ffc24a7c',
          featureName: 'Mobilize Approved from Field Count Initial Open',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5a82131f-89aa-4bd1-9617-10b37204610d',
          featureName: 'Mobilize Approved to Field Count Initial Open',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f7fb6b43-deea-429a-b0ad-afc4cd234f6f',
          featureName: 'Mobilize Pending from Mobilize Approved',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c1fc982b-9523-4d13-a608-299196d5331d',
          featureName: 'Mobilize Pending to Mobilize Approved',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0fdb0f69-5fca-4e44-bef8-cdc0d33b6250',
          featureName: 'Mobilize Pull or Return from Mobilize Pending',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '81c2d775-a094-409a-a234-ba39b14e5aea',
          featureName: 'Mobilize Pull or Return to Mobilize Pending',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ecfa9d3f-ec3e-4a6e-8d6e-11f17f90b289',
          featureName: 'Add Tethering ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8a0e0228-2c2e-47fc-b42d-92f7a932515f',
          featureName: 'Item Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1e450f4a-52e7-4996-b268-f5fe4fcac9e7',
          featureName: 'Item Name',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2a1e7d1b-338d-4387-9800-754857bbbf37',
          featureName: 'Part Number',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '187ef446-f8e7-4239-b1e5-2c8a3202e7b9',
          featureName: 'Reminder',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0ae7def0-1b51-4a9f-a0f9-5ba21f339347',
          featureName: 'Retire ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '691576d7-4bd7-4ff0-a3d4-7f643e60909d',
          featureName: 'Tethering',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '50a55f25-b66b-4057-9277-1a79d7806594',
          featureName: 'Tool Group',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '699576de-f4d3-44ce-8477-1635fa2ef42e',
          featureName: 'Vendor Manufacturer Table',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e36c0916-0269-41a4-9a18-b67fcdea3a96',
          featureName: 'Add Related Equipment',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'be284f18-8362-41ce-8590-a7ca8bf284ff',
          featureName: 'Adjust recommended inventory level',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '57f0984d-a7b8-43c3-885f-50aab1efb391',
          featureName: 'Delete Related Equipment',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6b76a9b5-f009-4262-9084-1f3c1e2139b3',
          featureName: 'Inventory Template Details - Add items',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3ecf1123-931b-4a68-9624-76a28fb32518',
          featureName: 'Inventory Template Details - Remove Items',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '23e83c3e-c665-42da-96c2-fa93e3868077',
          featureName: 'Inventory Template Header',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3ab729ea-0459-4f61-a0c6-8fcfeaee5f25',
          featureName: 'Can Copy JobRequirements',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ff93cb57-d70c-4dc8-839e-6d5f8096033e',
          featureName: 'Can Copy Plants',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f43820bc-6d91-4f22-bd0e-2989506f14a4',
          featureName: 'By Job Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f14db4c5-e4fb-4c14-8eee-ae31f8401f36',
          featureName: 'Facility Manpower Report',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bcd648a1-e900-4beb-a83e-9dbf81abe46e',
          featureName: 'Requested Class',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd01acdcd-b8e7-4a27-97e0-129bd1699258',
          featureName: 'Search Candidates for ManPower position',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bafd328d-198d-4c55-9f7f-9c6d9cbd8154',
          featureName: 'Promotion Review View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '73e98d52-f8d0-4884-bf9d-62d3178cf5d3',
          featureName: 'Prospect Creation Use New Process ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'de82f656-6716-4d36-916d-32fec04e1f41',
          featureName: 'Container Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a4259d88-a89b-4110-8fcc-f10b9ee0a469',
          featureName: 'Inventory Count Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '62583997-4595-4603-8c0c-906f7b0e0cc6',
          featureName: 'Inventory Template Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '47f4ac9e-4d72-4aff-9f51-59bfd80d2d7d',
          featureName: 'Item Listing',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c694a074-ecda-4365-95d4-65874882f951',
          featureName: 'Move Items Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '09ba1cb6-f019-4354-b16c-604c294d5bc4',
          featureName: 'Bridge Logs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '37975e49-45c5-43a8-9292-c0f3d1686f65',
          featureName: 'Bridge Register',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0c2ef28f-343a-41ba-b2d4-75b25af5244b',
          featureName: 'Dashboard Info',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e4f56740-c83f-4387-aa89-edbfd5a880ae',
          featureName: 'Dispatch Skill',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '659a1059-2a2f-468e-9439-b7bbf8415c33',
          featureName: 'Entra Apps',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '530b02df-14dc-4574-91f7-ee4d3561d51a',
          featureName: 'Flock Management',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4394de1c-bb52-4f65-8d9f-04d07059a4e8',
          featureName: 'Flock context',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'cf69b2ec-526d-40fd-8d63-d6cb23daef14',
          featureName: 'Hosts',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '164a1cb0-46bf-410a-bb73-8523038167c5',
          featureName: 'Memory',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '28672a6c-d531-4582-86b3-1eecebdefe89',
          featureName: 'People',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9b113f1e-660e-429d-99c9-5dee0d736606',
          featureName: 'Planner',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e5015311-72b0-443f-8f1c-ea222e0da7a4',
          featureName: 'Quota',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6dfaa8db-d816-4eaa-a3ae-ec0c38184e5f',
          featureName: 'Terminals',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '29892d4c-7e26-4641-974b-0da0845a8bf5',
          featureName: 'Tokens',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'dfa8a7bd-d4f4-409d-baa0-d911d07992fc',
          featureName: 'Coach Forms Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b2ce0bc0-02cb-448e-beb8-441044d54652',
          featureName: 'Coach Forms Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f8d60a48-0ee7-4ae4-8b5d-fdb4dd79c9c6',
          featureName: 'Advanced Fields',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3142ee11-52bc-40b3-8790-19c066401895',
          featureName: 'Form Builder Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fe41744b-8772-40d3-b156-c7025575376f',
          featureName: 'Form Controls Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '346813e2-23af-499a-9eed-88343de4953f',
          featureName: 'Form Controls Page Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0b651d09-ac9a-4fbf-82bf-d1cb9d9f95d1',
          featureName: 'Form Properties Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7dcec9d4-2a98-461b-ab4a-13af2c963bf7',
          featureName: 'Form Properties Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0a880df3-af95-483c-a72f-ec4aee304648',
          featureName: 'AI Review',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '924040ca-a6f3-4ee4-8996-4e950e7cb97b',
          featureName: 'Approval Comments',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9c5654f6-c17a-4bd4-9421-a4bfca343887',
          featureName: 'Can Add Lessons Learned',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9d19a2c5-8cca-4f27-af13-d7d91297a36c',
          featureName: 'Can Coach Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0519f2d8-d921-4781-aff2-0f3a7993d613',
          featureName: 'Can Comment Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e236c13e-1a3a-42e9-8907-cdbac3c5acb1',
          featureName: 'Can Edit Accepted Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1b6292d2-0713-402c-9b85-91315870005f',
          featureName: 'Can Edit Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '542b5b34-c99c-4e4d-8692-080bb5796026',
          featureName: 'Can Edit Rejected Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1e629ab6-eb2f-4d54-9ccd-3a6bfbe1f8bc',
          featureName: 'Can Mention Roles',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '927e3ffb-bac7-4968-aaa4-1d1bfdce9c17',
          featureName: 'Can Reclassify Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '599cbd44-19d1-4c48-b513-630b44c53164',
          featureName: 'Can Review Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c0f447c6-80fe-4221-afa2-380e855805ef',
          featureName: 'Audit Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '04d4d05d-28c7-411e-8464-c57e40b739d8',
          featureName: 'Form to PDF',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '3b35b3db-9039-43f1-bc4e-edb60b04289f',
          featureName: 'Incident Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4d03e67e-5df3-4fdf-b0d5-cc75d48608d9',
          featureName: 'Last Modified Details',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'eff18972-0622-4485-b292-05bfe7e0933b',
          featureName: 'Observation Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '69f9390f-e468-4bb3-838f-d8746a8a4f55',
          featureName: 'Reporting Forms',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '13403f64-25e0-4880-9918-fcd715bc5551',
          featureName: 'Lessons Learned Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '82c888da-88a0-4327-9fbf-1166f5be4a93',
          featureName: 'Lessons Learned Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b4af09f2-dbaf-4458-a671-b048322ce6b8',
          featureName: 'Lessons Learned Submitted By Filter and Column',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f050a6d9-dae5-4a86-b5c0-24566a322b5c',
          featureName: 'My Submissions Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b84227e1-7407-4e35-b978-cc4cdb9e7701',
          featureName: 'My Submissions Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '18e6e753-9d0b-4afc-b425-7cdee9e48ffb',
          featureName: 'Participation Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b347a0c6-ac8b-49de-b8cb-59b8925cb383',
          featureName: 'Participation Grid',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4472fb37-a2f9-4f14-a8f4-07620e43e901',
          featureName: 'Review Forms Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd9804356-4f69-4793-963f-51868ea57c8d',
          featureName: 'Review Forms Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '16edd1fd-6836-47f9-acaf-112d4793ed84',
          featureName: 'Custom Dashboard Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '88a657a5-5341-4562-a204-ec96ca003d01',
          featureName: 'Safety Forms Custom Dashboard Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '59405ceb-ec12-4fe8-ad05-ca9f33370182',
          featureName: 'Submission Requirements Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0fb974a5-3daa-4272-9956-f63e1c5c5983',
          featureName: 'Submission Requirements Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '359c1292-c414-4466-9c55-634390120147',
          featureName: 'Training Sign In Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5942494a-3ed2-4114-88e6-dd54ff8f0352',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '57dd6829-e787-4a4f-9251-4597957ea864',
          featureName: 'View Assignments Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '01a52acb-bd72-4eb1-9a22-e7a435defce8',
          featureName: 'Classification Frequencies',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f412fa53-e28d-427a-ada3-a6fb07446956',
          featureName: 'Individual Assignments',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'da2489a0-92d4-4094-b6d0-1e3460f88635',
          featureName: 'Coach Tier 5 Ops',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9cdda093-f325-4b88-a5ef-646931ff2beb',
          featureName: 'View Detail Screens',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5e1d19cc-349c-4f5b-8b7e-e225f74289a7',
          featureName: 'View Extended Detail Tabs',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '066c002a-bc11-4d94-8901-923d1b0ecc33',
          featureName: 'View eForm Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd3837282-c750-44ed-b713-d4177827360c',
          featureName: 'Create Hazard Card',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '799ff1bb-457a-4a9b-a980-8b045eb067bf',
          featureName: 'Mitigation Strategy',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd511fcc7-6af4-454c-bc54-852ee7e87b0d',
          featureName: 'View Participation Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a1625cfe-a88b-463a-952d-362880f92785',
          featureName: 'View Submissions Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'de3f1c4f-9a0e-4aa8-ab13-7ff1c1f14d9f',
          featureName: 'My Statistics',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4efe5925-047e-4279-9c83-4e276743748c',
          featureName: 'View Summary Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9b7fcceb-b6fb-477e-a212-fd38e129912f',
          featureName: 'HSE / Ops Manager',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2464475c-64d0-4302-9fe8-1197ae1a282b',
          featureName: 'See Hazard Card from Snapshot',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a4510751-0963-43b0-b388-b26ec531363d',
          featureName: 'View Weekly Snapshots Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'be9cebc7-000f-4b1d-b934-a1ff45b442bf',
          featureName: 'Software Roles View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '86360685-b65d-4ff9-8f8a-6a9b513324a2',
          featureName: 'App Architecture Diagram',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6f761912-ca9b-49e0-a21b-79b969fc031d',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '47b55d7c-938a-424b-ae37-2707270c681d',
          featureName: 'View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '28784b18-05ca-4dc2-b504-de4ff42e8ecb',
          featureName: 'JsonViewer',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fbd50168-9f84-4377-8934-f43a3673ebd3',
          featureName: 'View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f8784f8b-9172-4506-836b-a140eb4b65cd',
          featureName: 'Board view',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '09b8ab51-6c6e-4d33-a06f-1c777e5ea2e9',
          featureName: 'Doers view',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '94ae527e-f200-4240-92d1-033388cff715',
          featureName: 'Edit',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '538e0663-5d58-4594-9987-9881b8c5b969',
          featureName: 'Leads view',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'd0825dc3-bef9-47e1-a89d-45c13c2c3636',
          featureName: 'SteerCo view',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c5ece46c-dfdf-4f7d-99d6-907e8851b5e4',
          featureName: 'Manage Job Titles roles',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9b8eb151-d9fe-455d-8c6f-37fe228d4d2f',
          featureName: 'Ryn Replay Player',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '8091fc8c-5d8b-414c-b739-b00e0202e859',
          featureName: 'View Session Replays (web-operations-management)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e6e59f83-fa63-47a9-89c2-255463e402b3',
          featureName: 'View Session Replays (web-ryns-roost)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2a5e7f2b-3867-4e00-9145-5dd0315d2095',
          featureName: 'View Session Replays (web-safety)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5bd5764f-67e1-48c8-8096-2937d81dda8c',
          featureName: 'View Session Replays (web-software-security)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'eaa27703-71eb-40e7-8cae-eec5e11bf58e',
          featureName: 'View Session Replays (web-sparta)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '03468945-95d6-4b1b-8446-a965bf18d582',
          featureName: 'View Session Replays (web-warehouse)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '239ad970-35b5-4bdb-8084-4fa832596a47',
          featureName: 'View Session Replays (web-my-ups)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ecee7e71-b323-4b26-94cd-47cb4d9ef0ae',
          featureName: 'View Session Replays (web-resource-allocatiion)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6618a57f-7f5b-4758-a3c0-2620bdc89fc0',
          featureName: 'View Session Replays (web-ryn-replay)',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c8d8cf07-2ac4-4cd1-a0f4-e8ef287e85d0',
          featureName: 'View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bcb52b0a-20ff-41e8-858b-4fd808f429c1',
          featureName: 'View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '94fb2fae-2619-49b8-bd56-44eb1a498b86',
          featureName: 'Security Request',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '62b7bd25-c44c-4543-ab06-33672276f7cb',
          featureName: 'User Applications',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e67ce720-6939-4c35-84c5-bca38479c8d5',
          featureName: 'User security details',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b02b0758-fc33-4bf1-8e0b-857cf56e38d4',
          featureName: 'User Security Request Options',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '22ba4b8c-aebe-4d9f-a570-3ca351896342',
          featureName: 'User Tenants',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '34822095-cf27-4757-99fe-ddef9337cb10',
          featureName: 'View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c96ed056-9a9e-4c2f-9501-41ec8c77d139',
          featureName: 'Administration Tab',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '437d4612-a6d9-4068-9e41-1c204e4b3217',
          featureName: 'ManageReleaseNotes',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e07ec7bf-f800-4328-9f34-6edbc655292d',
          featureName: 'User Companies',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '005a181c-5fba-45cd-b1fb-4ce1812aad41',
          featureName: 'User Info',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '4579db13-a6b6-4180-a52e-b5097969c5e4',
          featureName: 'User Jobs ',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '01efeef3-dcde-4a4f-b049-1a57eafd0f4f',
          featureName: 'User PR Groups',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '186ea356-8da6-40a2-a2e2-6c968514fe7f',
          featureName: 'User Roles',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1ae20435-f0dc-4208-a1bf-ea6b28f42247',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c342b9f0-bcb0-4b00-970d-9ba3f2beacfe',
          featureName: 'Email Notifications Admin',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '17896141-0df3-4483-b89e-db9602905083',
          featureName: 'Create and Export Timesheets',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bacf9be7-6d29-47af-a19c-c36afb1c8220',
          featureName: 'Foreman Time Manager Custom View',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '56cb8db9-3bf7-4295-b2fc-19669f02ecc7',
          featureName: 'Foreman Time Manager Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fd3ede44-f616-4a13-9d46-2e3dc0fa1e12',
          featureName: 'ROF Watch List Power BI',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'e8d1a4a5-3651-4e67-aafc-35f22e0dcff7',
          featureName: 'Test2',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '1e197dd0-3c60-46f0-ae95-6622969a572f',
          featureName: 'Test Feature',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '0f20f8df-237c-46df-83c2-2e7ade159e7a',
          featureName: 'Track Reconciliation Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '187e0197-d828-4adb-80e2-57dab1b96304',
          featureName: 'Theory of Constraints App',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '90fd40d8-f921-4813-be70-78e012de35a6',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6d0be249-a010-4c2d-97e0-1eb8a95f9ba0',
          featureName: 'Delete Transcript',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'fc0f4cea-06c9-4511-9d1b-a67af19eff6e',
          featureName: 'View All Transcripts',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '9f75f3e1-9f77-4e12-89a8-15bcd303c472',
          featureName: 'Older Builds',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5898b1b7-639a-4f88-9b0b-558bbbe81c6e',
          featureName: 'Ask Ryn',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c1f3f631-09aa-49e6-a75e-9ce986cf9a97',
          featureName: 'Adjust Variance Count',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a269270b-405b-4998-bc1b-80ef15fda1c0',
          featureName: 'Cycle Count Admin',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '10f8433a-b2d2-447f-8b4e-5d6a36c58ee8',
          featureName: 'Cycle Count User',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '71ed3885-4690-47ed-9ca4-e80e639c5900',
          featureName: 'Kits page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'ab2cea1a-8747-4dd9-9945-dc6760451ec9',
          featureName: 'Can Edit Discount',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'bc876d00-1f91-443f-a244-b440d8dde4db',
          featureName: 'Backorders Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'b941148b-2bb5-4bce-9aab-10c9533773dc',
          featureName: 'Code Atlas Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'a8963d3a-b37d-4c29-8c2b-fd9f25a6cec2',
          featureName: 'Customer Replacement Outreach',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6932a460-3053-47f1-b52a-03910c74fa84',
          featureName: 'Customers Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '924f0265-a18c-4cbb-afbc-dee0a035a1f7',
          featureName: 'Diagram Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'c4b5ba0d-4d25-4773-aad7-a8fb8ca3dd02',
          featureName: 'Dock Log Custom Views',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'cc2ac3bf-b568-4c3f-b66b-579be4ef74fa',
          featureName: 'Dock Log Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '28715e6c-35ac-4061-b14e-fa3ecdbef7e0',
          featureName: 'Add New Material',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6bbe00b9-cdb8-4e0e-85f8-f078b5db8fb2',
          featureName: 'Add/Edit Sub Location',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '650d3ba1-6b1b-4a40-9123-5583bc6759cc',
          featureName: 'Can See Prices',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '91be7b7b-c884-487b-a990-19d3d660c2ca',
          featureName: 'Inventory History',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '337b4a35-b676-4595-9666-79c93706dff1',
          featureName: 'Inventory Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '95882485-ece3-4891-9ea7-c3d6e9a68e2e',
          featureName: 'Material Notes',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '99351c33-dbef-44e9-a793-0118e658ca4f',
          featureName: 'material_photos',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '5c68fccb-9835-495c-b73d-b7515bbe1903',
          featureName: 'MaterialVPUpdateModal',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f241823c-d3bc-4f37-84e3-2ac66bc9b626',
          featureName: 'Knowledge Base Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '241c1f90-b1eb-473e-a7a8-12bf542cf7b8',
          featureName: 'Create Sublocations',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'de44241a-d910-430a-a394-15a93c956aa8',
          featureName: 'Label Maker Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '6cbf82bd-c638-4efe-aca3-74b72cbd9cf6',
          featureName: 'Inventory Management',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '7bcd71af-5ad3-4342-ab38-7fa55d5b79fa',
          featureName: 'Transfer Stock and Print',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2e8f856a-f5e2-4771-92c8-77757e776918',
          featureName: 'Create Quote',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '55f83681-5cf2-4d91-ab80-96c0beb535cb',
          featureName: 'Edit Order',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '21b8f4db-284e-4844-8329-5abaad28eb9f',
          featureName: 'Fulfill',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '08206fea-e1cf-4182-ad7c-93ae0053b277',
          featureName: 'Order Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '2a799019-3609-431a-82c8-f1fb9b593a1d',
          featureName: 'Quote to Sales Order',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '67be1f7b-dd0a-4a91-8b5a-ce045a004c60',
          featureName: 'All Reports',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '978943a2-1630-4f72-82c4-d53d8539612d',
          featureName: 'qc_admin',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '58b58d18-b31a-4c36-a5ab-9ea5b71981d5',
          featureName: 'qc_page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: '909cbe6a-cbe9-4082-baf9-9ad10c734d8d',
          featureName: 'Vendor Page',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },

        {
          permissionId: null,
          featureId: 'f3cefd46-175e-4170-b215-5d73237d8099',
          featureName: 'Weekly Summary',
          uniqFeatureName: '',
          viewFeature: false,
          readAll: false,
          editAll: false,
          approvalNeeded: false,
          containsSelf: false,
          readSelf: false,
          editSelf: false,
          approvalNeededSelf: false,
          company: false,
          job: false,
        },
      ],
    },
  ],
  hasError: false,
  message: null,
};
